<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  async created() {
    // 如果 localStorage 中有登录状态，验证后端 session 是否有效
    if (this.$store.state.user.isLoggedIn) {
      try {
        await this.$store.dispatch('user/getInfo')
      } catch (error) {
        // session 已过期，清除本地状态
        console.log('Session expired, logging out...')
        await this.$store.dispatch('user/resetToken')
        if (this.$route.path !== '/login') {
          this.$router.push(`/login?redirect=${this.$route.path}`)
        }
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
}
</style>
